var _defs, _rect, _rect2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercardDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    fill: "none",
    viewBox: "0 0 34 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    fill: "#1B1D1E",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 33.7,
    height: 23.7,
    x: 0.15,
    y: 0.15,
    stroke: "#fff",
    strokeOpacity: 0.3,
    strokeWidth: 0.3,
    rx: 2.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M21.533 19.113c3.744 0 6.779-3.074 6.779-6.866 0-3.791-3.035-6.865-6.78-6.865a6.702 6.702 0 00-4.396 1.64 6.702 6.702 0 00-4.397-1.64c-3.744 0-6.78 3.074-6.78 6.866 0 3.791 3.036 6.865 6.78 6.865a6.701 6.701 0 004.397-1.64 6.702 6.702 0 004.397 1.64z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M17.136 17.473a6.887 6.887 0 002.382-5.226 6.887 6.887 0 00-2.382-5.225 6.702 6.702 0 014.397-1.64c3.744 0 6.779 3.074 6.779 6.865 0 3.792-3.035 6.866-6.78 6.866a6.702 6.702 0 01-4.396-1.64z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M17.136 17.473a6.886 6.886 0 002.382-5.226 6.886 6.886 0 00-2.382-5.225 6.886 6.886 0 00-2.382 5.225c0 2.093.924 3.967 2.382 5.226z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardDark);
export default __webpack_public_path__ + "static/media/mastercard-dark.d9ebe31a.svg";
export { ForwardRef as ReactComponent };